import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { msalInstance } from './auth/msalInstance';

const root = ReactDOM.createRoot(document.getElementById('root'));

// MSAL must be initialized before any other MSAL API runs.
msalInstance
  .initialize()
  .catch((err) => {
    console.error('MSAL init failed:', err);
  })
  .finally(() => {
    root.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
    );
  });
